import { useState, useContext } from 'react';
import ContextStates from '../context/ContextStates';

const FSubproductos = () => {
    const [precioextra, setPrecioextra] = useState(0)
    const [nota, setNota] = useState('')
    const { subProductos, setSubProductos, setProducto, productoAux, setViewOpen } = useContext(ContextStates);

    const setItem = (val) => {
        let rData = [...subProductos]
        let auxExtra = parseFloat(precioextra);
        rData.forEach(element => {
            if (element.id === val) {
                //console.log("agregado: ",element)
                if (element.seltipo === '1') {
                    if (element.agregado === '0') {
                        element.agregado = '1'
                        if (element.precio !== '0') {
                            auxExtra = auxExtra + parseFloat(element.precio)
                        }
                    }
                    else {
                        element.agregado = '0'
                        auxExtra = auxExtra - parseFloat(element.precio)
                    }
                }
                else {
                    element.agregado = '1'
                    auxExtra = auxExtra + parseFloat(element.precio)
                }
            }
            else {
                if (element.seltipo === '2') {
                    element.agregado = '0'
                }
            }
            //console.log("auxextra: ", auxExtra)
            setPrecioextra(auxExtra)
        });
        setSubProductos(rData)
    }

    const complete = () => {
        let temp = productoAux;
        temp.subproductos = [...subProductos]
        temp.precioextra = precioextra;
        temp.nota = nota;
        setProducto(temp)
        setViewOpen(false)
    }

    return (
        <div className="w-full mx-auto">
            <div className='w-full sm:flex'>
                <div className='bg-gray-50 rounded-lg p-5 w-full mb-5'>
                    {typeof subProductos !== 'undefined' && subProductos.map((item, index) =>
                        <div key={index} className="radio">
                            <label className='flex'>
                                {item.seltipo === '1' ? (
                                    <input
                                        type="checkBox"
                                        name="subProducto"
                                        value={item.id}
                                        onChange={() => setItem(item.id)}
                                        checked={item.agregado === '1' ? true : false}
                                        className='mr-5'
                                    />

                                ) : (
                                    <input
                                        type="radio"
                                        value="0"
                                        name="subProducto"
                                        className='mr-2'
                                        onChange={() => setItem(item.id)}
                                        checked={item.agregado === "1" ? true : false}
                                    />
                                )}
                                <p className=''>
                                    <span className='w-1/2'>{item.descripcion}</span>
                                    {item.precio !== '0' && (<span className='w-1/2 ml-14 font-semibold'>$ {item.precio}</span>)}
                                </p>
                            </label>
                        </div>
                    )}
                </div>
            </div>
            <div className='w-full p-3'>
                <label htmlFor="observaciones" className="block text-gray-600 uppercase font-bold">Notas del producto</label>
                <input
                    className="py-2 px-3 w-full rounded border border-gray-300"
                    id="nota"
                    placeholder="Notas del producto"
                    type="text"
                    value={nota}
                    onChange={(e) => setNota(e.target.value)}
                />
            </div>
            <div className='w-1/3 mx-auto'>
                <button type='button'
                    className='w-full p-3 bg-green-500 text-white uppercase font-semibold rounded'
                    onClick={() => complete()}
                >
                    Aceptar
                </button>
            </div>
        </div>
    )
}

export default FSubproductos